<template>

    <v-dialog
        v-model="dialog"
        persistent
        max-width="380"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            title="Enviar mensaje"
        >
          <v-icon>mdi-message</v-icon>
        </v-btn>
      </template>

      <v-card>

        <v-card-title class="text-h5 title-messages">
          Enviar mensaje a @{{profile}}
        </v-card-title>

        <v-textarea
            class="mx-2 mt-2"
            outlined
            auto-grow
            v-model="message">
        </v-textarea>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="dialog = false"
              icon
          >
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
          <v-btn
              @click="send()"
              icon
              :color="sended === false ? '' : 'green'"
          >
            <v-icon v-if="sended === false">mdi-send</v-icon>
            <v-icon v-else>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
import Messages from "@/services/Messages";

import store from "../store";
export default {
  props: ['profile', 'profileId'],
  data () {
    return {
      sended : false,
      message: '',
      dialog: false,
    }
  },
  methods: {
    send(){
      Messages.send(store.state.tokenStored, this.profileId, this.message).then((response)=> {

        if (!response || !response.success || response.success === false) {
          alert('Ha habido un error:' + JSON.stringify(response))
          return
        }
        let obj = this
        this.sended = true

        setTimeout(function(){
          obj.message = ''
          obj.dialog = false
        }, 500);

      })
    }
  }
}
</script>
<style type="text/css">
  .title-messages{
    background: linear-gradient(90deg, rgba(251,251,251,1) 0%, rgba(97,97,97,0.75) 100%);
    color:black;
    fotn-weight:bold;
  }
</style>